import { useNavigate } from "react-router-dom";
import logo from "../../assets/images/logo.jpg";
import desktop from "../../assets/images/desktop.png";
import human from "../../assets/images/human.png";
import correct from "../../assets/images/correct.png";

const C = {
    purple: "#5B1FA0",
    yellow: "#F5C518",
    teal: "#00BCD4",
    orange: "#FF5722",
    text: "#1a1a2e",
    gray: "#555",
};

const steps = [
    {
        img: desktop,
        accentColor: C.teal,
        titleColor: C.purple,
        title: "Цахим өргөдөл",
        items: [
            "Хувийн мэдээлэл",
            "Тантай танилцах асуултууд",
            "Таны Томүжинд суралцах хүслийг мэдэх асуултууд",
        ],
        highlight: "Дээрх мэдээллээ бөглөөд өргөдлийн хураамжаа төлж өргөдлөө илгээнэ.",
        note1: "Өргөдлийн хураамж: ₮60,000",
        note2: "Өргөдлийн хариу имэйлээр очно. Тэнцсэн тохиолдолд:",
        arrow: true,
    },
    {
        img: human,
        accentColor: C.orange,
        titleColor: C.purple,
        title: "Бататгах сорил",
        desc: "Энэ нь таны цахим өргөдөлдөө бичсэн мэдээлэл үнэн, бодит болохыг баталгаажуулах зорилготой байна.",
        highlight: "Бататгах сорилд биечлэн оролцох ба хэзээ гэдгийг утас, имэйлээр мэдэгдэнэ.",
        note1: "Ямар нэг хураамж төлөхгүй.",
        note2: "Сорилын хариу имэйлээр очно. Тэнцсэн тохиолдолд:",
        arrow: true,
    },
    {
        img: correct,
        accentColor: C.purple,
        titleColor: C.purple,
        title: "Сургалтын гэрээ",
        desc: "Томүжин Алтернатив сургуульд суралцах эрхээ авч, сургалтын гэрээг байгуулна.",
        arrow: false,
    },
];

function Arrow() {
    return (
        <div className="hidden md:flex" style={{ alignItems: "center", paddingTop: 60, flexShrink: 0 }}>
            <div style={{ width: 32, height: 2, background: C.yellow }} />
            <div style={{ width: 0, height: 0, borderTop: "7px solid transparent", borderBottom: "7px solid transparent", borderLeft: `10px solid ${C.yellow}` }} />
        </div>
    );
}

function StepCard({ step }) {
    const ac = step.accentColor;
    return (
        <div style={{ flex: 1, minWidth: 260, maxWidth: 320, display: "flex", flexDirection: "column", alignItems: "center" }}>
            {/* Icon */}
            <div style={{ width: 100, height: 100, marginBottom: 18 }}>
                <img src={step.img} alt={step.title} style={{ width: "100%", height: "100%", objectFit: "contain" }} />
            </div>

            {/* Title */}
            <h3 style={{ fontSize: 20, fontWeight: 800, color: step.titleColor, margin: "0 0 14px", textAlign: "center", fontFamily: "'Raleway',sans-serif" }}>
                {step.title}
            </h3>

            {/* Bullet items */}
            {step.items && (
                <ul style={{ listStyle: "none", padding: 0, margin: "0 0 14px", width: "100%", textAlign: "left" }}>
                    {step.items.map((item, i) => (
                        <li key={i} style={{ fontSize: 14, color: C.gray, marginBottom: 6, paddingLeft: 14, position: "relative", lineHeight: 1.5 }}>
                            <span style={{ position: "absolute", left: 0, color: C.purple, fontWeight: 700 }}>•</span>
                            {item}
                        </li>
                    ))}
                </ul>
            )}

            {/* Description */}
            {step.desc && (
                <p style={{ fontSize: 14, color: C.gray, textAlign: "center", lineHeight: 1.65, margin: "0 0 14px" }}>
                    {step.desc}
                </p>
            )}

            {/* Spacer — highlight box нэг түвшинд байлгана */}
            <div style={{ flex: 1 }} />

            {/* Highlight box */}
            {step.highlight && (
                <div style={{ border: `2px solid ${ac}`, borderRadius: 8, padding: "12px 16px", marginBottom: 10, width: "100%", boxSizing: "border-box" }}>
                    <p style={{ fontSize: 14, fontWeight: 700, color: C.purple, margin: 0, textAlign: "center", lineHeight: 1.55 }}>
                        {step.highlight}
                    </p>
                </div>
            )}

            {step.note1 && (
                <p style={{ fontSize: 12, color: C.purple, margin: "0 0 4px", fontStyle: "italic", textAlign: "center" }}>
                    {step.note1}
                </p>
            )}
            {step.note2 && (
                <p style={{ fontSize: 12, color: C.gray, margin: 0, textAlign: "center", lineHeight: 1.5 }}>
                    {step.note2}
                </p>
            )}
        </div>
    );
}

export default function HomePage() {
    const navigate = useNavigate();

    return (
        <div style={{ minHeight: "100vh", background: "#fff", fontFamily: "'Raleway','Segoe UI',sans-serif" }}>

            {/* Logo */}
            <div style={{ display: "flex", justifyContent: "center", paddingTop: 36, paddingBottom: 4 }}>
                <img src={logo} alt="Томүжин" style={{ height: 64, objectFit: "contain" }} />
            </div>

            {/* Title */}
            <div style={{ textAlign: "center", padding: "20px 24px 36px" }}>
                <h1 style={{ fontSize: 24, fontWeight: 700, color: C.purple, margin: 0, lineHeight: 1.2, letterSpacing: -0.3, fontFamily: "'Raleway',sans-serif" }}>
                    Томүжин Алтернатив сургуулийн элсэлтийн үе шатууд
                </h1>
            </div>

            {/* Steps row */}
            <div style={{ maxWidth: 1060, margin: "0 auto", padding: "0 32px 56px" }}>
                <div style={{ display: "flex", alignItems: "stretch", justifyContent: "center", gap: 24, flexWrap: "wrap" }}>
                    {steps.map((step, i) => (
                        <>
                            <StepCard key={i} step={step} />
                            {step.arrow && <Arrow key={`arrow-${i}`} />}
                        </>
                    ))}
                </div>

                {/* CTA — Цахим өргөдөл (5-11) ба 1-р ангийн өргөдөл */}
                <div style={{ display: "flex", justifyContent: "center", gap: 18, marginTop: 44, flexWrap: "wrap" }}>
                    <button
                        onClick={() => navigate("/application")}
                        style={{ background: C.yellow, color: "#fff", border: "none", borderRadius: 50, padding: "15px 52px", fontSize: 16, fontWeight: 800, cursor: "pointer", boxShadow: "0 4px 20px rgba(245,197,24,0.35)", fontFamily: "inherit", letterSpacing: 0.3, transition: "transform 0.15s" }}
                        onMouseEnter={e => e.currentTarget.style.transform = "scale(1.04)"}
                        onMouseLeave={e => e.currentTarget.style.transform = "scale(1)"}
                    >
                        Цахим өргөдлөө эхлүүлэх
                    </button>
                    <button
                        onClick={() => navigate("/elementary")}
                        style={{ background: "#fff", color: C.purple, border: `2px solid ${C.purple}`, borderRadius: 50, padding: "13px 44px", fontSize: 16, fontWeight: 800, cursor: "pointer", boxShadow: "0 4px 20px rgba(123,47,190,0.15)", fontFamily: "inherit", letterSpacing: 0.3, transition: "transform 0.15s" }}
                        onMouseEnter={e => e.currentTarget.style.transform = "scale(1.04)"}
                        onMouseLeave={e => e.currentTarget.style.transform = "scale(1)"}
                    >
                        1-р ангийн өргөдөл
                    </button>
                </div>
            </div>

        </div>
    );
}